import { styled } from 'goober'

export const Wrapper = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex-wrap: wrap;
  gap: .8rem;
  margin: .8rem;
`
